/**
 * @ Author: mzc
 * @ Create Time: 2024-07-03 19:51:46
 * @ Modified by: mzc
 * @ Modified time: 2024-07-05 16:29:16
 * @ Description: 选择采购商品
 */
import dayjs from "dayjs";

const initalState = {
	originDataSource: [],
	options: {
		current: 1,
		pageSize: 20
	},
	tabActive: 0
};
const procurementSelectGoodsReducer = (state = initalState, action) => {
	switch (action.type) {
		case "PROCUREMENTSELECTGOODS_UPDATE_OPTIONS":
			return { ...state, options: { ...action.payload } };
		case "PROCUREMENTSELECTGOODS_UPDATE_TABACTIVE":
			return { ...state, tabActive: action.payload };
		case "PROCUREMENTSELECTGOODS_UPDATE_ORIGINDATASOURCE":
			return { ...state, originDataSource: [...action.payload] };
		case "PROCUREMENTSELECTGOODS_RESET":
			return { ...JSON.parse(JSON.stringify(initalState)) };
		default:
			return state;
	}
};

export default procurementSelectGoodsReducer;
